import React from 'react';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';

import cl from './Contacts.module.css';

const Contacts = (props) => {
  const position = props.aboutData.coordinates?.split(', ') || [
    40.808712, -73.946818,
  ];

  return (
    <section className={cl.contact}>
      <img
        className={cl.big_image}
        src="https://www.iai.co.il/drupal/sites/default/files/2022-02/Contact%20us.jpg"
      />
      {/* <div className={cl.profile}>
        <div className={cl.info}>
          <h1>Contact us</h1>
        </div>
      </div> */}
      <div className={cl.main}>
        <div style={{ flex: 1 }}>
          <p>
            If you have any questions or concerns, please do not hesitate to
            contact us.
          </p>
          <p>We would love to hear from you, contact us on:</p>
          <div className={cl.contacts}>
            <p>
              Email:{' '}
              <a href={'mailto: support@' + props.domain}>
                support@{props.domain}
              </a>
            </p>
            <p>{props.shopName} Shop Group</p>
            <p>{props.aboutData.address}</p>
            <p>
              Tel: <a href="tel:+18464947855">1-846-494-7855 x844</a>
            </p>
          </div>
        </div>
        <div style={{ flex: 2 }}>
          <MapContainer
            center={position}
            zoom={12}
            scrollWheelZoom={false}
            style={{ height: '450px', width: '80%', margin: '0 auto' }}
          >
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <Marker position={position} />
          </MapContainer>
        </div>
      </div>
    </section>
  );
};

export default Contacts;
